export class PreviewRtcPeerConnectionFactory {
    /**
     * @param iceServers A STUN server is used to get an external network address. TURN servers are used to relay traffic if direct (peer to peer)
     * connection fails. Example: const iceServers: RTCIceServer[] = [{ urls: ["stun:stun2.1.google.com:19302"] }];
     */
    constructor(iceServers, role) {
        this.iceServers = iceServers;
        this.role = `${role}WebRTC`;
    }
    create(signalingChannel, clientId, peerId, peerScope, peerCanUseWebRTC) {
        let peerConnection;
        if (peerCanUseWebRTC) {
            const configuration = { iceServers: this.iceServers };
            peerConnection = new RTCPeerConnection(configuration);
        }
        console.log(`${this.role}: starting connection with peer ${peerId} (scope ${peerScope}). Signaling type ${signalingChannel.type}.`);
        return this.createConnection(signalingChannel, peerConnection, clientId, peerId, peerScope);
    }
}
//# sourceMappingURL=preview-rtc-peer-connection-factory.js.map